import React, { Component } from 'react';

import {
    Button,
    Confirm,
    Form,
    Icon,
    Input,
    Header,
    Label,
    Menu,
    Message,
    Modal,
    Segment } from "semantic-ui-react";

import { API } from 'aws-amplify';

import ReactFlagsSelect from 'react-flags-select';
import 'react-flags-select/css/react-flags-select.css';

// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";

// Load the list of countries (code -> name) that are displayed in the countries drop-down
import _countries from 'react-flags-select/es/countries';

const measurementOptions = [
    { key: 'imperial', value: 'imperial', text: 'Imperial (feet, pounds, etc.)' },
    { key: 'metric', value: 'metric', text: 'Metric (meters, kilos, etc.)' }
];

const currencyOptions = [
    { key: 'usd', value: 'usd', text: 'US Dollars (USD)' },
    { key: 'eur', value: 'eur', text: 'Euro (EUR)' }
];

class Country extends Component {

    constructor(props) {
      super(props);

      // Populate the state with initial empty data for rending
      this.state = {
          country: {
              measurement: 'imperial',
              currency: 'usd',
              categories: []
          },
          countries: [],
          loading: true,
          showMessage: false,
          showDeleteCountryConfirm: false,
          showNewCatDialog: false,
          showDeleteCatConfirm: false,
          isNewCountry: false,
      };

      this.reactTable = React.createRef();
    }

    showDeleteCountryConfirm = () => this.setState({ showDeleteCountryConfirm: true })
    hideDeleteCountryConfirm = () => this.setState({ showDeleteCountryConfirm: false })
    showNewCatDialog = () => this.setState({ showNewCatDialog: true, newCat: { cost: {} } })
    hideNewCatDialog = () => this.setState({ showNewCatDialog: false })
    showDeleteCatConfirm = () => this.setState({ showDeleteCatConfirm: true })
    hideDeleteCatConfirm = () => this.setState({ showDeleteCatConfirm: false })
    showMessage = () => this.setState({ showMessage: true })
    hideMessage = () => this.setState({ showMessage: false })

    getCountry = async (countryCode) => {
        // Do not update the table if a new country is being selected.
        if (this.state.isNewCountry) {
            return
        }

        try {
            this.setState({ loading: true });
            let responseCountry = await API.get('countrycost', '/countries/object/' + countryCode);

            // Default values if missing
            responseCountry.measurement = responseCountry.measurement || 'imperial';
            responseCountry.currency = responseCountry.currency || 'usd';

            let index = this.state.countries.indexOf(countryCode);
            this.setState({ country: responseCountry, current: index },
                () => this.refs.userFlag.updateSelected(responseCountry.id)
            );
        } catch(error) {
            console.error('Error getting country ' + countryCode, error);
        } finally {
            this.setState({ loading: false });
        }
    }

    getCountryIds = async (countryToLoad) => {
        try {
            let response = await API.get('countrycost', '/countries');
            let sortedIds = response.countries.sort((countryCodeA, countryCodeB) => {
                let nameA = _countries[countryCodeA];
                let nameB = _countries[countryCodeB];                
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }              
                return 0;
            });
            countryToLoad = countryToLoad || sortedIds[0];
            this.setState({ countries: sortedIds }, () => this.getCountry(countryToLoad));
        } catch(error) {
            console.error('Error getting country IDs', error);
        }
    }

    saveCountry = async () => {

        let savedCountryId = this.refs.userFlag.state.selected;
        try {
            let countryToSave;

            // If a new country has currently finished being edited, gather the details.
            if (this.state.isNewCountry) {
                countryToSave = {
                    id: savedCountryId,
                    measurement: this.state.country.measurement,
                    currency: this.state.country.currency,
                    categories: this.reactTable.current.resolvedData
                }
            } else {
                countryToSave = this.state.country;
            }

            this.setState({ loading: true });
            await API.post('countrycost', '/countries', { body: countryToSave });
            // TODO Dialog for success, reload the countries wihout jumping to the first country

        } catch (error) {
            console.error('Failed to save country', error);
        } finally {
            this.setState({ loading: false, isNewCountry: false });
            this.getCountryIds(savedCountryId);
        }
        // alert(JSON.stringify(response, null, 2));
    }

    deleteCountry = async () => {
        try {
            this.hideDeleteConfirm();
            this.setState({ loading: true });
            await API.del('countrycost', '/countries/object/' + this.state.country.id);

        } catch (error) {
            console.error(error);
        } finally {
            this.setState({ loading: false });
            this.getCountryIds();
        }
    }

    newCountry = () => {
        this.setState({isNewCountry: true});
    }

    onChange = (e, data) => {
        if (data.name === 'measure') {
            this.setState(prevState => {
                prevState.country.measurement = data.value;
                return prevState;
            });
        } else if (data.name === 'currency') {
            this.setState(prevState => {
                prevState.country.currency = data.value;
                return prevState;
            });
        }
    }

    addNewCatValue = (e, data) => {
        this.setState(prevState => {
            if (data.name === 'name') {
                prevState.newCat[data.name] = data.value;
            } else {
                prevState.newCat.cost[data.name] = data.value;
            }
            return prevState;
        });
    }

    addNewCat = () => {
        this.setState(prevState => {
            prevState.country.categories.push(prevState.newCat);
            prevState.showNewCatDialog = false;
            return prevState;
        });
    }

    deleteCat = () => {
        this.setState(prevState => {
            prevState.country.categories.splice(this.state.selectedCat, 1);
            prevState.showDeleteCatConfirm = false;
            return prevState;
        });
    }

    onRowClicked = (state, rowInfo, column, instance) => {
        return {
            onClick: (e, handleOriginal) => {
                if (rowInfo !== undefined) {
                    this.setState({ selectedCat: rowInfo.index})
                }
                // React-Table uses onClick internally to trigger events.
                // By default a custom 'onClick' handler will override this functionality.
                // Fire the original onClick handler.
                if (handleOriginal) {
                  handleOriginal()
                }
            }
        }
    }

    renderEditable = (cellInfo) => {
        let path = cellInfo.column.id.split('.');

        // Get the last property name and delete it from the path.
        let propName = path[path.length - 1];
        path.pop();

        // Start with the category to update
        let objToUpdate = this.state.country.categories[cellInfo.index];
        objToUpdate = path.reduce((obj, prop) => obj[prop], objToUpdate);

        return (
          <div
            contentEditable
            suppressContentEditableWarning
            onBlur={e => {
                objToUpdate[propName] = e.target.innerHTML;
                this.setState( this.state );
            }}
            dangerouslySetInnerHTML={{
              __html: objToUpdate[propName]
            }}
          />
        );
      }

    stepCountry = (e) => {
        let isNext = e.currentTarget.id === 'btnNext'
        let val = (isNext ? this.state.current + 1 : this.state.current - 1)
        this.setState({ current: val, isNewCountry: false },
            () => {
                let code = this.state.countries[this.state.current];
                this.getCountry(code);
            }
        );
    }

    componentDidMount() {
        this.getCountryIds();
    }

    // Get CountryDisplay displaying the country date passed to it
    // To change the country you need to move the flag selector up into this component.
    // Need to set the layout of the overall app still.
    render() {
        const DismissableMessage = (props) => {
            if (props.hidden) {
                return <Label as='a' content='Help' icon='help circle' onClick={this.showMessage} />
            }

          return <Message info onDismiss={this.hideMessage}
              header='Add, edit, and delete estimated building costs for a country.'
              list={[
                  'All monetary values are in the currency shown in the Currency field.',
                  'To add a new country, click New and search for the country in the list below. Update the attributes and categories, then click Save.',
                  'To edit a country select it in the list below, modify the values, then click Save.',
                  'To delete a country select it in the list below, click Delete, and confirm or cancel the deletion when the confirmation dialog displays.',
                  'To add a new category to the table, click Add Category and enter the values in the dialog. Once finished adding new categories to the table click Save.',
                  'To delete a category from the table, select any cell in the row to delete, then click Delete Category. Once finished deleting categories from the table click Save.',
              ]} />
        }

        return (
            <Segment>
                <DismissableMessage hidden={!this.state.showMessage} />
                <Menu stackable>
                    <Menu.Item>
                        <Button id='btnPrevious' color='blue' icon labelPosition='left' onClick={this.stepCountry}
                                disabled={this.state.current <= 0}>
                            Previous
                            <Icon name='left arrow' />
                        </Button>
                    </Menu.Item>
                    <Menu.Item>
                        <ReactFlagsSelect
                            countries={this.state.countries}
                            blackList={this.state.isNewCountry}
                            ref="userFlag"
                            selectedSize={13}
                            onSelect={this.getCountry}
                            searchable={true}
                            searchPlaceholder="Search..." />
                    </Menu.Item>
                    <Menu.Item>
                        <Button id='btnNext' color='blue' icon labelPosition='right' onClick={this.stepCountry}
                                disabled={this.state.current >= (this.state.countries.length - 1)}>
                            Next
                            <Icon name='right arrow' />
                        </Button>
                    </Menu.Item>

                    <Menu.Menu position='right'>
                        <Menu.Item>
                            <Button color='blue' onClick={this.newCountry} disabled={this.state.isNewCountry} >
                                <Icon name='pencil alternate' /> New
                            </Button>
                        </Menu.Item>
                        <Menu.Item >
                            <Button color='green' onClick={this.saveCountry}>
                                <Icon name='checkmark' /> Save
                            </Button>
                        </Menu.Item>
                        <Menu.Item>
                            <Button color='red' onClick={this.showDeleteCountryConfirm} disabled={this.state.isNewCountry}>
                                <Icon name='remove' /> Delete
                            </Button>
                            <Confirm
                                content='Are you sure you want to delete the country?'
                                open={this.state.showDeleteCountryConfirm}
                                cancelButton='No'
                                confirmButton='Yes'
                                onCancel={this.hideDeleteCountryConfirm}
                                onConfirm={this.deleteCountry}
                            />
                        </Menu.Item>
                    </Menu.Menu>
                </Menu>

                <Segment loading={this.state.loading} >
                    <Header as='h4'>
                        <Icon name='list' size='small'/>
                        <Header.Content>
                            Country Attributes
                        </Header.Content>
                    </Header>
                    <Form>
                        <Form.Group widths='equal'>
                            <Form.Select
                                name='measure'
                                fluid={true}
                                label='Measurement system'
                                onChange={this.onChange}
                                options={measurementOptions}
                                value={this.state.country.measurement} />

                            <Form.Select
                                name='currency'
                                fluid={true}
                                label="Currency"
                                onChange={this.onChange}
                                options={currencyOptions}
                                value={this.state.country.currency} />

                        </Form.Group>
                    </Form>
                </Segment>

                <Segment loading={this.state.loading} >
                    <Header as='h4'>
                        <Icon name='building' size='small'/>
                        <Header.Content>
                            Build Categories
                        </Header.Content>
                    </Header>
                    <Menu stackable>
                        <Menu.Menu position='right'>
                            <Menu.Item>
                                <Button color='blue' onClick={this.showNewCatDialog}>
                                    <Icon name='plus' />Add Category
                                </Button>

                                <Modal size='mini' open={this.state.showNewCatDialog} >
                                  <Header icon='pencil alternate' content='New Build Category' />
                                  <Modal.Content>
                                    <p>
                                      Enter the category name, low cost, and high cost.
                                    </p>
                                    <Input name='name' placeholder='Name' fluid={true} onChange={this.addNewCatValue} />
                                    <br />
                                    <Input name='from' placeholder={`Low cost in ${this.state.country.currency === 'usd' ? 'US dollars' : 'Euro'}`} onChange={this.addNewCatValue} />
                                    <br />
                                    <br />
                                    <Input name='to' placeholder={`High cost in ${this.state.country.currency === 'usd' ? 'US dollars' : 'Euro'}`} onChange={this.addNewCatValue} />

                                  </Modal.Content>
                                  <Modal.Actions>
                                    <Button color='red' onClick={this.hideNewCatDialog}>
                                      <Icon name='remove' /> Cancel
                                    </Button>
                                    <Button color='green' onClick={this.addNewCat}>
                                      <Icon name='checkmark' /> Add
                                    </Button>
                                  </Modal.Actions>
                                </Modal>

                            </Menu.Item>
                            <Menu.Item>
                                <Button color='red' onClick={this.showDeleteCatConfirm}>
                                    <Icon name='remove' /> Delete Category
                                </Button>

                                <Confirm
                                    content='Are you sure you want to delete the selected category?'
                                    open={this.state.showDeleteCatConfirm}
                                    cancelButton='No'
                                    confirmButton='Yes'
                                    onCancel={this.hideDeleteCatConfirm}
                                    onConfirm={this.deleteCat}
                                />

                            </Menu.Item>
                        </Menu.Menu>
                    </Menu>
                    <ReactTable
                        data={this.state.country.categories}
                        ref={this.reactTable}
                        columns={[
                            {
                                Header: "Category",
                                accessor: "name",
                                Cell: this.renderEditable,
                                minWidth: 150
                            },
                            {
                                Header: () => <span>Cost Per Square {this.state.country.measurement === 'imperial' ? 'Feet' : 'Meters'} in {this.state.country.currency === 'usd' ? 'US Dollars' : 'Euro'} </span>,
                                columns: [
                                    {
                                        Header: "Low",
                                        accessor: "cost.from",
                                        Cell: this.renderEditable,
                                        minWidth: 50,
                                        style: {textAlign: "center"}
                                    },
                                    {
                                        Header: "High",
                                        accessor: "cost.to",
                                        Cell: this.renderEditable,
                                        minWidth: 50,
                                        style: {textAlign: "center"}
                                    }
                                ]
                            }
                        ]}
                        className="-striped -highlight"
                        defaultSorted={[ { id: "name" } ]}
                        defaultPageSize={20}
                        getTdProps={this.onRowClicked}
                    />
                </Segment>
            </Segment>
        );
    }

}


export default Country;
